import styled from 'styled-components';

import { Text12 } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const TextGrey = styled(Text12)`
  color: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.GreyDarkest })};
  display: inline;
`;
export const TextBlack = styled(Text12)`
  color: ${ct({ Dark: Colors.Black, Light: Colors.Black })};
  display: inline;
`;

export const Circle = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-flex;
  margin-right: 2px;
  margin-bottom: 1px;
`;

export const QueryBlock = styled.span`
  text-overflow: ellipsis;
  max-width: 50vw;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
`;

export const QueryContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 6px;
`;

export const QueryTooltipContainer = styled.div`
  /*
    This important is used here, because
    it allows us to not think about coloring options
    in the child components, this is a special case
    where I think important can be used
  */
  * {
    color: ${Colors.White} !important;
  }
`;
